
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useTextColorClass } from "@/components/ui/text-coloring";
import { useIsMobile } from "@/hooks/use-mobile";
import { supportLabels } from "@/i18n";
import { getLanguage } from "@/utils/languageUtils";

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQSectionProps {
  faqItems: FAQItem[];
}

export const FAQSection = ({ faqItems }: FAQSectionProps) => {
  const { baseText, subtleText, isDark } = useTextColorClass();
  const isMobile = useIsMobile();
  const supportLabels_i18n = supportLabels(getLanguage());

  return (
    <div className="glass-card rounded-xl border border-border/60 p-4 sm:p-6 my-4 sm:my-6">
      <div className="flex items-center gap-2 mb-4">
        <h2 className="text-lg sm:text-xl font-semibold">{supportLabels_i18n.faq?.title}</h2>
      </div>
      <Accordion type="single" collapsible className="space-y-2">
        {faqItems.map((item, index) => (
          <AccordionItem
            key={index}
            value={`item-${index}`}
            className="bg-background/80 border rounded-lg overflow-hidden"
          >
            <AccordionTrigger
              className={`px-4 py-3 sm:px-6 sm:py-4 hover:no-underline hover:bg-muted/50 text-left ${baseText} font-medium ${isMobile ? "text-base min-h-[56px]" : ""} touch-manipulation`}
            >
              {item.question}
            </AccordionTrigger>
            <AccordionContent
              className={`px-4 pb-4 pt-1 sm:px-6 sm:pb-6 ${subtleText} leading-relaxed ${isMobile ? "text-sm" : ""}`}
            >
              {item.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};
